<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>File Manager</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="p-3">

  <table mat-table [dataSource]="dataSource" matSort matSortActive="date_created" matSortDirection="desc" matSortDisableClear>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? dataSource.selectAllToggle() : null"
          [checked]="dataSource.selection.hasValue() && dataSource.isAllSelected()"
          [indeterminate]="dataSource.selection.hasValue() && !dataSource.isAllSelected()"
          matTooltip="Toggle select all files in this list.">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
          (change)="$event ? dataSource.selection.toggle(row.id) : null"
          [checked]="dataSource.selection.isSelected(row.id)"
          matTooltip="Toggle select this file.">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the id of the file.">
        ID #
      </th>
      <td mat-cell *matCellDef="let file">
        {{ file.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="thumbnail">
      <th mat-header-cell *matHeaderCellDef>

      </th>
      <td mat-cell *matCellDef="let file">
        <img matListItemAvatar class="rounded-0" style="cursor: pointer; max-width: 80px; max-height: 80px;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [src]="file.url" [alt]="file.name" *ngIf="isImage(file.name)">
        <img matListItemAvatar class="rounded-0" style="cursor: pointer; max-width: 80px; max-height: 80px;" (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)" [alt]="file.name" src="./assets/images/document-placeholder.png" *ngIf="!isImage(file.name)" />
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the name of the file.">
        File Name
      </th>
      <td mat-cell *matCellDef="let file">
        {{ file.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef mat-sort-header matTooltip="Toggle sorting by the date the file was created at.">
        Created At
      </th>
      <td mat-cell *matCellDef="let file">
        {{ (file.date_created * 1000) | timezoneConvertMedium }}
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>

      <td mat-cell *matCellDef="let file">
        <button
          mat-icon-button
          ngxClipboard
          matTooltip="Click this button to copy the file URL to your clipboard."
          [cbContent]="file.url"
          (click)="onCopiedURL()"
          style="cursor: pointer;">
          <mat-icon>content_copy</mat-icon>
        </button>

        <button
          mat-icon-button
          matTooltip="Click this button to download the file."
          (click)="utils.onDownloadFromTemporaryURL(file.url, file.name, $event)"
          style="cursor: pointer;">
          <mat-icon>download</mat-icon>
        </button>

        <button
          mat-icon-button
          matTooltip="Click this button to view the file."
          (click)="onOpenUrl(file.url)"
          style="cursor: pointer;">
          <mat-icon>preview</mat-icon>
        </button>

        <button
          mat-icon-button
          color="warn"
          matTooltip="Click this button to delete the file."
          (click)="onRemoveUploadedFile(file.id, $event)"
          style="cursor: pointer;">
          <mat-icon color="warn">delete</mat-icon>
        </button>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="listColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: listColumns"></tr>
  </table>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex justify-content-end px-2 py-1">
  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>

  <app-file-browse-button
    (selectedFiles)="onSelectFiles($event)"
    [filesCount]="dataSource?.total | async">
  </app-file-browse-button>

  <button mat-button mat-dialog-close class="my-2 ml-1 mr-2">Done</button>
</mat-dialog-actions>
